import { Drawer, Typography, Card, Button, Icon, Tooltip, notification, Alert } from "antd";
import React from "react";
import { TableComp } from "sz-react-utils";
import Request, { MEDIA_URL } from "../../request";

const companyDetails = localStorage.getItem('company-details') ? JSON.parse(localStorage.getItem('company-details')) : {};
const companyCurrency = companyDetails && companyDetails.companyCurrency ? companyDetails.companyCurrency : 'INR';
const { Title } = Typography;
class BranchInvoiceApprovalDrawer extends React.Component {
    state = {
        visible: true,
        count: 0,
        loading: false
    }


    onClose = () => {
        this.setState({ visible: false }, () => {
            this.props.onClose();
        })
    }

    apiRequest = () => {
        return new Promise(async (resolve) => {
            let response = await Request.getBranchGeneratedInvoices();
            if (response.total <= 0) {
                this.onClose();
            }
            this.setState({ count: response.total })
            return resolve(response);
        })
    }

    handleInvoiceAction = async (_id, status) => {
        let data = {
            _id,
            status
        };
        if (status === "Approved") {
            let branchInvoiceNumber = prompt('Enter Invoice Number (as per your Book Records)');
            if (!branchInvoiceNumber) {
                notification.error({
                    message: 'Enter Invoice Number'
                });
                return;
            }
            data['branchInvoiceNumber'] = branchInvoiceNumber;
        } else if (status === "Rollback") {
            let rejectionReason = prompt('Rollback Reason');
            if (!rejectionReason) {
                notification.error({
                    message: 'Enter Reason For Rollback'
                });
                return;
            }
            data['rejectionReason'] = rejectionReason;
        }
        this.setState({ loading: true });
        let response = await Request.changeBranchInvoiceStatus(data);
        this.setState({ loading: false });
        if (response.success) {
            notification.success({
                message: response.message
            })
        } else {
            notification.error({
                message: response.message
            })
        }
        this.table.current.reload();

    }

    constructor(props) {
        super(props)
        this.table = React.createRef();
    }

    render() {
        let { visible, loading, count } = this.state;
        const currencySymbols = {
            USD: "$",      // US Dollar
            EUR: "€",      // Euro
            GBP: "£",      // British Pound
            INR: "₹",      // Indian Rupee
            AUD: "A$",     // Australian Dollar
            CAD: "C$",     // Canadian Dollar
            JPY: "¥",      // Japanese Yen
            CNY: "¥",      // Chinese Yuan
            NZD: "NZ$",    // New Zealand Dollar
            CHF: "CHF",    // Swiss Franc
            SGD: "S$",     // Singapore Dollar
            HKD: "HK$",    // Hong Kong Dollar
            SEK: "kr",     // Swedish Krona
            NOK: "kr",     // Norwegian Krone
            DKK: "kr",     // Danish Krone
            ZAR: "R",      // South African Rand
            AED: "د.إ",    // UAE Dirham
            SAR: "﷼",     // Saudi Riyal
            THB: "฿",      // Thai Baht
            MYR: "RM",     // Malaysian Ringgit
            IDR: "Rp",     // Indonesian Rupiah
            KRW: "₩",      // South Korean Won
            TRY: "₺",      // Turkish Lira
            RUB: "₽",      // Russian Ruble
            BRL: "R$",     // Brazilian Real
            MXN: "$",      // Mexican Peso
            PHP: "₱",      // Philippine Peso
            PLN: "zł",     // Polish Zloty
            HUF: "Ft",     // Hungarian Forint
            CZK: "Kč",     // Czech Koruna
        };
        const columns = [
            {
                title: 'Actions',
                key: 'actions',
                width: 80,
                align: 'center',
                render: (text, record) => {
                    return (
                        <div style={{ display: 'flex', gap: '8px', justifyContent: 'center' }}>
                            <Button
                                loading={loading}
                                type="primary"
                                size="small"
                                icon="check"
                                shape="circle"
                                style={{ background: '#52c41a', borderColor: '#52c41a', fontSize: '12px' }}
                                onClick={() => this.handleInvoiceAction(record._id, 'Approved')}
                                title="Approve"
                            />
                            <Button
                                loading={loading}
                                type="danger"
                                size="small"
                                icon="close"
                                shape="circle"
                                style={{ fontSize: '12px' }}
                                onClick={() => this.handleInvoiceAction(record._id, 'Rollback')}
                                title="Rollback"
                            />
                        </div>
                    );
                }
            },
            {
                title: '#',
                key: 'serialNumber',
                width: 50,
                align: 'center',
                render: (text, record, index) => (
                    <span style={{ fontWeight: 600, color: '#8c8c8c' }}>{index + 1}</span>
                )
            },
            {
                title: 'Invoice Details',
                key: 'invoiceDetails',
                width: 180,
                render: (text, record) => {
                    var claimNum = record && record.claimNumber ? record.claimNumber : '-';
                    var invStatus = record && record.status ? record.status : 'PENDING';

                    var invUrl = record && record.invoiceUrl ? record.invoiceUrl : null;

                    return (
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                            <span style={{ fontWeight: 700, color: '#262626', fontSize: '13px' }}>
                                {invUrl ? (
                                    <a href={`${MEDIA_URL}${invUrl}`} target="_blank" rel="noopener noreferrer" style={{ color: '#1890ff', textDecoration: 'underline' }}>
                                        {claimNum}
                                    </a>
                                ) : claimNum}
                            </span>

                            <div style={{ display: 'flex', gap: '8px', marginTop: '4px' }}>
                                {invUrl && (
                                    <a href={`${MEDIA_URL}${invUrl}`} target="_blank" rel="noopener noreferrer" style={{ fontSize: '11px', color: '#13c2c2' }}>
                                        <Icon type="file-pdf" style={{ marginRight: 2 }} /> View Invoice
                                    </a>
                                )}
                            </div>
                        </div>
                    );
                }
            },
            {
                title: 'Student & Course Details',
                key: 'studentCourseDetails',
                width: 320,
                render: (text, record) => {
                    // Root key 'studentDetails' mapping securely matching new schema structure
                    var studentsList = record && record.studentDetails ? record.studentDetails : [];

                    return (
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                            {studentsList.map((item, idx) => {
                                var studentConversion = item.conversionRate ? item.conversionRate : '-';
                                var studentCurrency = item.currency ? item.currency : 'EUR';
                                var studentSymbol = currencySymbols[studentCurrency] ? currencySymbols[studentCurrency] : studentCurrency + ' ';
                                var companySymbol = currencySymbols[companyCurrency] ? currencySymbols[companyCurrency] : companyCurrency + ' ';

                                var itemComm = item.commissionTotal ? Number(item.commissionTotal) : 0;
                                var itemGrossConverted = item.grossPaymentReceived ? Number(item.grossPaymentReceived) : 0;
                                var itemAssociateAmt = item.associateAmount ? Number(item.associateAmount) : 0;
                                var itemSharingRate = item.sharingRate ? item.sharingRate : '-';

                                var currentTerm = item.termNumber ? item.termNumber : '1';

                                return (
                                    <div key={idx} style={{
                                        padding: '8px 0',
                                        borderBottom: idx !== studentsList.length - 1 ? '1px dashed #e8e8e8' : 'none'
                                    }}>
                                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                            <div style={{ fontWeight: 700, color: '#141414', fontSize: '13px' }}>
                                                <Icon type="user" style={{ marginRight: 6, color: '#1890ff' }} />
                                                {item.studentName}
                                            </div>
                                            <span style={{
                                                fontSize: '11px',
                                                fontWeight: 700,
                                                color: '#096dd9',
                                                background: '#e6f7ff',
                                                border: '1px solid #91d5ff',
                                                padding: '1px 6px',
                                                borderRadius: '4px'
                                            }}>
                                                T{currentTerm}
                                            </span>
                                        </div>
                                        <div style={{ fontSize: '11px', color: '#595959', margin: '3px 0' }}>
                                            <Icon type="bank" style={{ marginRight: 6, color: '#bfbfbf' }} />
                                            {item.universityInstitutionName || '-'}
                                        </div>
                                        <div style={{ fontSize: '11px', color: '#8c8c8c', marginBottom: '6px' }}>
                                            {item.courseName}
                                        </div>

                                        <div style={{ display: 'flex', flexDirection: 'column', gap: '2px', background: '#fafafa', padding: '6px', borderRadius: '4px', border: '1px solid #f0f0f0' }}>
                                            <span style={{ fontSize: '11px', color: '#434343' }}>
                                                <strong>Comm (Foreign):</strong> {studentSymbol}{itemComm.toFixed(2)}
                                            </span>
                                            <span style={{ fontSize: '11px', color: '#434343' }}>
                                                <strong>Gross Converted:</strong> {companySymbol}{itemGrossConverted.toFixed(2)}
                                            </span>
                                            <span style={{ fontSize: '11px', color: '#237804', fontWeight: 600 }}>
                                                <strong>Branch Share ({itemSharingRate}):</strong> {companySymbol}{itemAssociateAmt.toFixed(2)}
                                            </span>
                                            <span style={{
                                                fontSize: '10px',
                                                marginTop: '2px',
                                                color: '#595959',
                                                display: 'inline-block'
                                            }}>
                                                <Icon type="swap" style={{ marginRight: 4, color: '#8c8c8c' }} />
                                                Exchange Rate: 1 {studentCurrency} = {studentConversion} INR
                                            </span>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    );
                }
            },
            {
                title: 'Financial Breakdown',
                key: 'financialBreakdown',
                width: 250,
                render: (text, record) => {
                    var companySymbol = currencySymbols[companyCurrency] ? currencySymbols[companyCurrency] : companyCurrency + ' ';

                    // Safely fetch pre-calculated root invoice layout amounts from the new schema
                    var amountBeforeTax = record && record.amountBeforeTax ? Number(record.amountBeforeTax) : 0;
                    var amountAfterTax = record && record.amountAfterTax ? Number(record.amountAfterTax) : 0;
                    var totalFinalPayout = record && record.totalAfterAdditionalDeduction ? Number(record.totalAfterAdditionalDeduction) : 0;
                    var deductionAmount = record && record.additionalDeductionAmount ? Number(record.additionalDeductionAmount) : 0;

                    var taxDetails = record && record.taxDetails ? record.taxDetails : [];
                    var deductionDetails = record && record.additionalDeductionDetail ? record.additionalDeductionDetail : [];

                    return (
                        <div style={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: '5px',
                            padding: '10px',
                            background: '#fff',
                            border: '1px solid #e8e8e8',
                            borderRadius: '8px',
                            boxShadow: '0 1px 4px rgba(0,0,0,0.02)'
                        }}>
                            {/* 1. Base Amount Before Tax */}
                            <div style={{ fontSize: '12px', color: '#595959' }}>
                                <span style={{ color: '#8c8c8c', marginRight: 4 }}>Amt Before Tax:</span>
                                <strong>{companySymbol}{amountBeforeTax.toFixed(2)}</strong>
                            </div>

                            {/* 2. Dynamic Taxes Mapping Block (CGST / SGST etc.) */}
                            {taxDetails.map((tax, idx) => (
                                <div key={idx} style={{ fontSize: '11px', color: '#434343', paddingLeft: '8px' }}>
                                    <span style={{ color: '#8c8c8c', marginRight: 4 }}>+ {tax.taxName} ({tax.taxValue}%):</span>
                                    {companySymbol}{Number(tax.taxAmount || 0).toFixed(2)}
                                </div>
                            ))}

                            {/* 3. Base Amount After Tax */}
                            <div style={{ fontSize: '12px', color: '#595959', borderTop: '1px dashed #f0f0f0', paddingTop: '4px' }}>
                                <span style={{ color: '#8c8c8c', marginRight: 4 }}>Amt After Tax:</span>
                                {companySymbol}{amountAfterTax.toFixed(2)}
                            </div>

                            {/* 4. Dynamic Deductions Block (TDS etc.) */}
                            {deductionDetails.map((ded, idx) => (
                                <div key={idx} style={{ fontSize: '11px', color: '#ff4d4f', paddingLeft: '8px' }}>
                                    <span style={{ color: '#bfbfbf', marginRight: 4 }}>{ded.taxName} ({ded.taxValue}%):</span>
                                    {companySymbol}{Number(ded.taxAmount || 0).toFixed(2)}
                                </div>
                            ))}

                            {/* 5. Final Net Payable Amount (Grand Payout) */}
                            <div style={{
                                fontSize: '13px',
                                fontWeight: 700,
                                color: '#237804',
                                borderTop: '1px solid #e8e8e8',
                                paddingTop: '6px',
                                marginTop: '2px'
                            }}>
                                <span style={{ fontSize: '11px', color: '#8c8c8c', fontWeight: 500, marginRight: 4 }}>Net Payable Amount:</span>
                                <div style={{ fontSize: '16px', fontWeight: 800, color: '#52c41a', marginTop: '2px' }}>
                                    {companySymbol}{totalFinalPayout.toFixed(2)}
                                </div>
                            </div>
                        </div>
                    );
                }
            },
            {
                title: 'Invoice Status',
                key: 'invoiceStatus',
                width: 140,
                align: 'center',
                render: (text, record) => {
                    var status = record && record.status ? record.status : 'PENDING';

                    var getStatusColors = function (currentStatus) {
                        var s = currentStatus ? currentStatus.toUpperCase() : 'PENDING';
                        var config = {
                            'PENDING': { color: '#faad14', bg: '#fffbe6', border: '#ffe58f' },
                            'APPROVED': { color: '#52c41a', bg: '#f6ffed', border: '#b7eb8f' },
                            'UNDER REVIEW': { color: '#1890ff', bg: '#e6f7ff', border: '#91d5ff' }
                        };
                        return config[s] || { color: '#595959', bg: '#f5f5f5', border: '#d9d9d9' };
                    };

                    var mainStyles = getStatusColors(status);

                    return (
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                            <span style={{
                                fontSize: '11px',
                                fontWeight: 700,
                                color: mainStyles.color,
                                background: mainStyles.bg,
                                border: '1px solid ' + mainStyles.border,
                                padding: '2px 8px',
                                borderRadius: '12px',
                                textTransform: 'uppercase'
                            }}>
                                {status}
                            </span>
                        </div>
                    );
                }
            }
        ];
        return (
            <Drawer
                title={`Invoices to Review:- ${count}`}
                placement="right"
                closable={true}
                onClose={this.onClose}
                width={800}
                visible={visible}>
                <Card bordered={true}>
                    <Alert
                        message="Branch Invoice Review & Approval Process"
                        description={
                            <ul style={{ paddingLeft: '15px', marginBottom: 0 }}>
                                <li><strong>Verify Invoice Details:</strong> Carefully review and confirm that all generated invoice breakdown metrics and student details are correct.</li>
                                <li><strong>Mandatory Invoice Number:</strong> Upon hitting approve, you will be prompted to enter the invoice number. Please ensure it perfectly matches your official <strong>Book Records</strong>.</li>
                                <li><strong>Next Workflow Step:</strong> After your approval, this invoice will be forwarded directly to the finance team for payment processing.</li>
                            </ul>
                        }
                        type="info"
                        showIcon
                        style={{ marginBottom: '20px' }}
                    />
                    <TableComp
                        ref={this.table}
                        columns={columns}
                        apiRequest={this.apiRequest}
                        extraProps={{ scroll: { x: 900 } }}
                        pagination={{
                            showSizeChanger: false,
                            defaultPageSize: 200,
                            pageSizeOptions: ['10', '20', '50', '100', '1000']
                        }}
                    />

                </Card>
            </Drawer>
        )
    }
}

export default BranchInvoiceApprovalDrawer;